declare namespace $ {

	type $mol_view__sub_shm_codex_app_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_codex_app_2 = $mol_type_enforce<
		ReturnType< $shm_codex_app['message_role'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_shm_codex_app_3 = $mol_type_enforce<
		ReturnType< $shm_codex_app['message_time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_codex_app_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_codex_app_5 = $mol_type_enforce<
		ReturnType< $shm_codex_app['message_text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_view__sub_shm_codex_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_codex_app_8 = $mol_type_enforce<
		({ 
			'busy': ReturnType< $shm_codex_app['busy'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_codex_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__hint_shm_codex_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_codex_app_14 = $mol_type_enforce<
		ReturnType< $shm_codex_app['goal_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_button_major__sub_shm_codex_app_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_codex_app_16 = $mol_type_enforce<
		ReturnType< $shm_codex_app['goal_set'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__sub_shm_codex_app_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_codex_app_18 = $mol_type_enforce<
		ReturnType< $shm_codex_app['goal_clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_codex_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_shm_codex_app_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_codex_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_codex_app_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_codex_app_24 = $mol_type_enforce<
		ReturnType< $shm_codex_app['message_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__hint_shm_codex_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_codex_app_27 = $mol_type_enforce<
		ReturnType< $shm_codex_app['prompt'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__submit_shm_codex_app_28 = $mol_type_enforce<
		ReturnType< $shm_codex_app['send'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_button_minor__hint_shm_codex_app_29 = $mol_type_enforce<
		ReturnType< $shm_codex_app['send_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_codex_app_30 = $mol_type_enforce<
		ReturnType< $shm_codex_app['send_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_codex_app_31 = $mol_type_enforce<
		ReturnType< $shm_codex_app['send'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_page__title_shm_codex_app_32 = $mol_type_enforce<
		ReturnType< $shm_codex_app['chat_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_codex_app_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_codex_app_34 = $mol_type_enforce<
		ReturnType< $shm_codex_app['chat_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_shm_codex_app_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_string__hint_shm_codex_app_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_codex_app_37 = $mol_type_enforce<
		ReturnType< $shm_codex_app['new_session_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_codex_app_38 = $mol_type_enforce<
		ReturnType< $shm_codex_app['create'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_button_major__hint_shm_codex_app_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_button_major__sub_shm_codex_app_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_codex_app_41 = $mol_type_enforce<
		ReturnType< $shm_codex_app['create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_codex_app_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__hint_shm_codex_app_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_codex_app_44 = $mol_type_enforce<
		ReturnType< $shm_codex_app['search_query'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_view__sub_shm_codex_app_45 = $mol_type_enforce<
		ReturnType< $shm_codex_app['session_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__attr_shm_codex_app_46 = $mol_type_enforce<
		({ 
			'current': ReturnType< $shm_codex_app['session_current'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_shm_codex_app_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_codex_app_48 = $mol_type_enforce<
		ReturnType< $shm_codex_app['session_select'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_pick__hint_shm_codex_app_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_shm_codex_app_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_shm_codex_app_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_codex_app_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_card__theme_shm_codex_app_53 = $mol_type_enforce<
		ReturnType< $shm_codex_app['message_theme'] >
		,
		ReturnType< $mol_card['theme'] >
	>
	type $mol_card__attr_shm_codex_app_54 = $mol_type_enforce<
		({ 
			'role': ReturnType< $shm_codex_app['message_role_key'] >,
		})  & ReturnType< $mol_card['attr'] >
		,
		ReturnType< $mol_card['attr'] >
	>
	type $mol_card__sub_shm_codex_app_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $mol_view__sub_shm_codex_app_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_codex_app_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_codex_app extends $mol_book2 {
		session_current( id: any): boolean
		session_title( id: any): string
		session_select( id: any, next?: any ): any
		session_current_title( ): string
		Sessions_current( ): $mol_view
		message_theme( id: any): string
		message_role_key( id: any): string
		message_role( id: any): string
		Message_role( id: any): $mol_paragraph
		message_time( id: any): string
		Message_time( id: any): $mol_paragraph
		Message_head( id: any): $mol_view
		message_text( id: any): string
		Message_text( id: any): $shm_hitalama_text
		Message_text_box( id: any): $mol_view
		chat_title( ): string
		chat_provider( ): string
		Chat_provider( ): $mol_view
		busy( ): boolean
		chat_status( ): string
		Chat_status( ): $mol_view
		Goal_settings_icon( ): $mol_icon_target
		Goal_title( ): $mol_view
		goal_status( ): string
		Goal_status( ): $mol_view
		Goal_head( ): $mol_view
		goal_text( next?: string ): string
		Goal_input( ): $mol_textarea
		goal_set( next?: any ): any
		Goal_set( ): $mol_button_major
		goal_clear( next?: any ): any
		Goal_clear( ): $mol_button_minor
		Goal_actions( ): $mol_view
		Goal( ): $mol_view
		Goal_settings( ): $mol_pick
		message_rows( ): readonly(any)[]
		Messages( ): $mol_view
		Messages_box( ): $mol_view
		chat_body( ): readonly(any)[]
		prompt( next?: string ): string
		send( next?: any ): any
		Prompt( ): $mol_textarea
		send_hint( ): string
		send_content( ): readonly(any)[]
		Send( ): $mol_button_minor
		Chat_page( ): $mol_page
		app_pages( ): readonly(any)[]
		new_session_title( next?: string ): string
		create( next?: any ): any
		New_session_title( ): $mol_string
		Create_icon( ): $mol_icon_plus
		Create( ): $mol_button_major
		New_session_bar( ): $mol_view
		search_query( next?: string ): string
		Search( ): $mol_search
		session_rows( ): readonly(any)[]
		Sessions( ): $mol_view
		session_id( next?: string ): string
		server_url( ): string
		Send_icon( ): $mol_icon_send
		Stop_icon( ): $mol_icon_stop
		Session( id: any): $mol_button_minor
		Sessions_pick( ): $mol_pick
		Message( id: any): $mol_card
		pages( ): ReturnType< $shm_codex_app['app_pages'] >
		No_session( ): $mol_view
		Sessions_panel( ): $mol_view
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map